import api from './client';
import { extrairNomeArquivo } from '../utils/contentDisposition';
import type { AuditoriaFiltros, AuditoriaResponse, NumerosAuditoria, TimelineFiltros, AuditoriaItem } from '../types/auditoria';

/** Espelha `AuditoriaController.MaxExport` — o backend trunca em silêncio
 *  nesse teto; o front usa o mesmo número pra DETECTAR o corte comparando
 *  com `totalCount` da listagem (mesmos filtros) e avisar o usuário.
 *  Paridade coberta por `auditoriaMaxExport.paridade.test.ts`. */
export const AUDITORIA_MAX_EXPORT = 5000;

export const auditoriaApi = {
  listar: async (filtros: AuditoriaFiltros): Promise<AuditoriaResponse> => {
    const params = new URLSearchParams();
    Object.entries(filtros).forEach(([k, v]) => {
      if (v === undefined || v === null) return;
      const s = String(v);
      if (s.length === 0) return;
      params.set(k, s);
    });
    const resp = await api.get<AuditoriaResponse>(`/auditoria?${params.toString()}`);
    return resp.data;
  },

  /** Devolve o blob + o nome de arquivo que o backend sugeriu (Content-Disposition),
   *  quando o header vem — caller cai num nome próprio se `filename` vier undefined. */
  exportar: async (filtros: AuditoriaFiltros): Promise<{ blob: Blob; filename?: string }> => {
    const params = new URLSearchParams();
    Object.entries(filtros).forEach(([k, v]) => {
      if (v === undefined || v === null) return;
      const s = String(v);
      if (s.length === 0) return;
      params.set(k, s);
    });
    const resp = await api.get(`/auditoria/export?${params.toString()}`, { responseType: 'blob' });
    return { blob: resp.data, filename: extrairNomeArquivo(resp.headers['content-disposition']) };
  },

  tipos: async (): Promise<string[]> => {
    const resp = await api.get<{ success: boolean; data: string[] }>('/auditoria/tipos');
    return resp.data.data;
  },

  usuariosDistintos: async (): Promise<string[]> => {
    const resp = await api.get<{ success: boolean; data: string[] }>('/auditoria/usuarios-distintos');
    return resp.data.data;
  },

  entidades: async (): Promise<string[]> => {
    const resp = await api.get<{ success: boolean; data: string[] }>('/auditoria/entidades');
    return resp.data.data;
  },

  /** Tudo que aconteceu com UMA entidade, em ordem cronológica (mais recente primeiro). */
  timeline: async ({ entidade, entidadeId, limite }: TimelineFiltros): Promise<AuditoriaItem[]> => {
    const params = new URLSearchParams({ entidade, entidadeId });
    if (limite) params.set('limite', String(limite));
    const resp = await api.get<{ success: boolean; data: AuditoriaItem[] }>(`/auditoria/timeline?${params.toString()}`);
    return resp.data.data;
  },

  /** Agregados da aba Números — GROUP BY ao vivo no backend, sem snapshot.
   *  `incluirAdmin` default false: o usuário `admin` (conta do suporte) fica fora dos números. */
  numeros: async (dias: number, incluirAdmin = false): Promise<NumerosAuditoria> => {
    const params = new URLSearchParams({ dias: String(dias) });
    if (incluirAdmin) params.set('incluirAdmin', 'true');
    const resp = await api.get<{ success: boolean; data: NumerosAuditoria }>(`/auditoria/numeros?${params.toString()}`);
    return resp.data.data;
  },
};
